enum DisplayNames {
  NavBar = 'NavBar',
  NavBarLeftContainer = 'NavBarLeftContainer',
  NavBarRightContainer = 'NavBarRightContainer',
  NavBarTab = 'NavBarTab',
  NavBarTabItem = 'NavBarTabItem',
  NavBarIconButton = 'NavBarIconButton',
  NavBarIconButtonItem = 'NavBarIconButtonItem'
}

export default DisplayNames;
